import { MentionUser } from "designSystem/components/editor/tributeService";
import { IUseUserProvider, UserQuery } from "designSystem/user";
import { UserProvider } from "src/Chat/api";
import { User } from "../api";

export class MSTeamsUserProvider extends UserProvider<User> implements IUseUserProvider<MentionUser> {
	private _cache: Record<string, MentionUser[]> = {};
	private readonly _userAvatarMap: Record<string, string> = {};

	/** avatars map */
	get userAvatarMap(): Record<string, string> {
		return this._userAvatarMap;
	}

	/**
	 * clear search cache
	 */
	clearSearchCache = (): void => {
		this._cache = {};
	};

	/**
	 * Implement user provider interface
	 */
	search = async (text: UserQuery): Promise<MentionUser[]> => {
		return null;
	};

	/**
	 * Implement search for cache
	 */
	searchWithCache = async (query: UserQuery): Promise<MentionUser[] | undefined> => {
		if (query != null && this.users) {
			const queryInput: string = query.input;
			const input = queryInput.toLowerCase();

			if (this._cache[input]) {
				return this._cache[input]
					.filter((user) => this.matchesNameOrEmail(user, queryInput));
			}

			const users = this.users
				.filter((user) => user.displayName.toLowerCase()
					.includes(input) || user.email?.toLowerCase()
					.includes(input))
				.sort((a, b) => a.displayName.localeCompare(b.displayName));
			const mentionUsers: MentionUser[] = this._cache[input] = users.map(({ displayName, email, userId }) => ({
				avatar: this.userAvatarMap[userId],
				email,
				fullName: displayName,
				lookup: displayName + " " + email,
				url: email,
			} as MentionUser));

			return mentionUsers;
		}
	};

	/**
	 * filter input by name and email
	 */
	private matchesNameOrEmail = (user: MentionUser, queryInput: string): boolean => user.fullName.toLowerCase()
		.includes(queryInput.toLowerCase()) ||
		user.email?.toLowerCase()
			.includes(queryInput.toLowerCase());

	constructor(users: User[], userAvatarMap: Record<string, string>) {
		super(users);
		this._userAvatarMap = userAvatarMap;
	}
}